import { differenceInDays } from 'date-fns';

const relativeNowDate = (date: Date): string => {
  const diffInDays = differenceInDays(new Date(), date);
  if (diffInDays === 0) return 'Hoy';
  if (diffInDays === 1) return 'Ayer';
  if (diffInDays === -1) return 'Mañana';
  if (diffInDays > 0) return `Hace ${diffInDays} días`;

  return `Faltan ${-diffInDays} días`;
};

export { relativeNowDate };
